// NotificationPrompt Modal - Frage nach Push-Benachrichtigungen
const NotificationPrompt = ({ 
  show, 
  t, 
  onAccept, 
  onDismiss 
}) => {
  if (!show) return null;
  
  return (
    <div className="notification-prompt-overlay">
      <div className="notification-prompt">
        <div className="prompt-icon">🔔</div>
        <h3>{t.dailyReminder}</h3>
        <p>{t.reminderQuestion}</p>
        <div className="prompt-buttons">
          <button 
            className="prompt-btn primary" 
            onClick={onAccept} 
            data-testid="notification-accept"
          >
            {t.yesRemindMe}
          </button>
          <button 
            className="prompt-btn secondary" 
            onClick={onDismiss} 
            data-testid="notification-dismiss"
          >
            {t.later}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPrompt;
